//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request } from '@/tools/index.js'
import { jssdk, isIphonex } from '@runwork/runwork-help'
import surveyList from '@/pages/list/Index.vue'
import BottomNavigation from '@/components/navigation/Index.vue'
import { dataList, listNum } from '@/mock/timu.js'
export default {
  name: 'index-page',
  data() {
    return {
      tabData: ['未完成', '已完成', '已过期'],
      tipsData: ['未完成', '已完成', '已过期'],
      currentIndex: 0,
      dataList: [],
      listNum: [],
      isRW3: undefined, // 平台标志 3.0 true
    }
  },
  components: {
    surveyList,
    BottomNavigation
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    status() {
      switch (this.currentIndex) {
        case 0:
          return 10
        case 1:
          return 20
        case 2:
          return 30
        default:
          return 10
      }
    },
  },
  watch: {
    currentIndex() {
      const loading = new this.$Loading()
      this.init()
        .then(() => {
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
  },
  async created() {
    const loading = new this.$Loading()
    try {
      await this.$nativeBridgeReady()
      await this.init()
      console.log('平台：', window.h5sdk ? 3.0 : 2.0)
      this.isRW3 = window.h5sdk ? true : false
      loading.close()
    } catch (err) {
      console.log(err)
      loading.close()
    }
  },
  methods: {
    init() {
      let promiseArr = [this.getListData(), this.getListNum()]
      return Promise.all(promiseArr)
    },
    getListData() {
      const userCode = this.user.ldap
      const params = {
        userCode,
        status: this.status,
      }
      return request('getBaseData', params).then((res) => {
        this.dataList = res
      })
    },
    getListNum() {
      const userCode = this.user.ldap
      return request('getListNum', { userCode }).then((res) => {
        this.listNum = res
        const { finishedCount, notFinishedCount, expireCount } = this.listNum
        this.tabData = [
          `未完成(${notFinishedCount})`,
          `已完成(${finishedCount})`,
          `已过期(${expireCount})`,
        ]
      })
    },
    gotoSearch() {
      this.$router.push('/search')
    },
    scrollTo(mark) {
      const scrollDom = document.querySelector('.scroll-y')
      scrollDom.scrollTop =
        document.getElementById(`nav-${mark}`).offsetTop - scrollDom.offsetTop
    },
    closeWebApp() {
      this.platform === 3 ? window.tt.closeWindow({}) : crh.closeWebApp()
    },
    getTips() {
      console.log('获取提示...')
      let uat = 'https://uat.rwork.crc.com.cn/docs/dock9BSwPFosbD5j7navMrJJFlb'
      let prd = 'https://app.rwork.crc.com.cn/docs/dock9YvmLiHRmBlcdpPuYaSDzrc'
      window.location.href =
        process.env.VUE_APP_H5_ENV !== 'production' ? uat : prd
    },
  },
}
